module.exports = __webpack_public_path__ + "static/media/bree-bio.e4df9d60.pdf";